import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Gift, ArrowRight, Shuffle } from 'lucide-react';

const ClusterSelectionGrid = () => {
    const navigate = useNavigate();

    const handleSelectCluster = (clusterPath) => {
        navigate(`/dashboard/clusters/${clusterPath}`);
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {/* Light Mix */}
            <div
                className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg hover:-translate-y-1 cursor-pointer"
                onClick={() => handleSelectCluster('lite-mix')}
            >
                <div className="relative p-4 sm:p-6 pb-10 sm:pb-12">
                    <div className="absolute -right-6 -top-6 w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-purple-500/10 to-pink-500/10 rounded-full"></div>

                    <div className="flex items-center mb-3 sm:mb-4">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white mr-3 sm:mr-4 flex-shrink-0">
                            <Shuffle size={20} className="sm:w-6 sm:h-6" />
                        </div>
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-800">Light Mix</h3>
                    </div>

                    <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 relative z-10">
                        Розыгрыши по расписанию с уникальными наградами.
                        Покупайте места и получайте денежные призы или билеты на следующий розыгрыш.
                        А также своим участием помогайте движению в Light Box и Light Keys.
                    </p>

                    <div className="bg-gradient-to-r from-purple-500/5 to-pink-500/5 rounded-lg p-2.5 sm:p-3 mb-3 sm:mb-4">
                        <div className="flex justify-between mb-1">
                            <span className="text-xs sm:text-sm text-gray-600">Стоимость:</span>
                            <span className="text-xs sm:text-sm font-medium bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">4 USDT</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-xs sm:text-sm text-gray-600">Награды:</span>
                            <span className="text-xs sm:text-sm font-medium bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">USDT + Keys + Mix</span>
                        </div>
                    </div>

                    <div className="absolute bottom-0 right-0 left-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 py-1.5 sm:py-2 px-4 sm:px-6 flex justify-end">
                        <span className="text-sm sm:text-base bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent font-medium flex items-center">
                            Подробнее <ArrowRight size={14} className="ml-1 sm:w-4 sm:h-4 text-pink-500" />
                        </span>
                    </div>
                </div>
            </div>
            {/* Light Box */}
            <div
                className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg hover:-translate-y-1 cursor-pointer"
                onClick={() => handleSelectCluster('lite-box')}
            >
                <div className="relative p-4 sm:p-6 pb-10 sm:pb-12">
                    <div className="absolute -right-6 -top-6 w-20 h-20 sm:w-24 sm:h-24 bg-blue-500/10 rounded-full"></div>

                    <div className="flex items-center mb-3 sm:mb-4">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-500 mr-3 sm:mr-4 flex-shrink-0">
                            <Box size={20} className="sm:w-6 sm:h-6" />
                        </div>
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-800">Light Box</h3>
                    </div>

                    <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 relative z-10">
                        Матричная структура с автоматическим заполнением. Присоединяйтесь и получайте доход от заполнения вашей матрицы партнерами.
                    </p>

                    <div className="bg-blue-500/5 rounded-lg p-2.5 sm:p-3 mb-3 sm:mb-4">
                        <div className="flex justify-between mb-1">
                            <span className="text-xs sm:text-sm text-gray-600">Тарифы:</span>
                            <span className="text-xs sm:text-sm font-medium text-blue-500">5 уровней</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-xs sm:text-sm text-gray-600">Доход до:</span>
                            <span className="text-xs sm:text-sm font-medium text-blue-500">$25,000</span>
                        </div>
                    </div>

                    <div className="absolute bottom-0 right-0 left-0 bg-blue-500/10 py-1.5 sm:py-2 px-4 sm:px-6 flex justify-end">
                        <span className="text-sm sm:text-base text-blue-500 font-medium flex items-center">
                            Подробнее <ArrowRight size={14} className="ml-1 sm:w-4 sm:h-4" />
                        </span>
                    </div>
                </div>
            </div>

            {/* Light Case */}
            <div
                className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg hover:-translate-y-1 cursor-pointer"
                onClick={() => handleSelectCluster('lite-case')}
            >
                <div className="relative p-4 sm:p-6 pb-10 sm:pb-12">
                    <div className="absolute -right-6 -top-6 w-20 h-20 sm:w-24 sm:h-24 bg-purple-500/10 rounded-full"></div>

                    <div className="flex items-center mb-3 sm:mb-4">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-purple-500/10 flex items-center justify-center text-purple-500 mr-3 sm:mr-4 flex-shrink-0">
                            <Grid size={20} className="sm:w-6 sm:h-6" />
                        </div>
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-800">Light Keys</h3>
                    </div>

                    <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 relative z-10">
                        Очередь выплат с гарантированным доходом. Приобретайте места в очереди и получайте выплаты от новых участников.
                    </p>

                    <div className="bg-purple-500/5 rounded-lg p-2.5 sm:p-3 mb-3 sm:mb-4">
                        <div className="flex justify-between mb-1">
                            <span className="text-xs sm:text-sm text-gray-600">Тарифы:</span>
                            <span className="text-xs sm:text-sm font-medium text-purple-500">4 уровня</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-xs sm:text-sm text-gray-600">Доход до:</span>
                            <span className="text-xs sm:text-sm font-medium text-purple-500">$50,000</span>
                        </div>
                    </div>

                    <div className="absolute bottom-0 right-0 left-0 bg-purple-500/10 py-1.5 sm:py-2 px-4 sm:px-6 flex justify-end">
                        <span className="text-sm sm:text-base text-purple-500 font-medium flex items-center">
                            Подробнее <ArrowRight size={14} className="ml-1 sm:w-4 sm:h-4" />
                        </span>
                    </div>
                </div>
            </div>

            {/* Light Loto */}
            <div
                className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg hover:-translate-y-1 cursor-pointer"
                onClick={() => handleSelectCluster('lite-loto')}
            >
                <div className="relative p-4 sm:p-6 pb-10 sm:pb-12">
                    <div className="absolute -right-6 -top-6 w-20 h-20 sm:w-24 sm:h-24 bg-amber-500/10 rounded-full"></div>

                    <div className="flex items-center mb-3 sm:mb-4">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-amber-500/10 flex items-center justify-center text-amber-500 mr-3 sm:mr-4 flex-shrink-0">
                            <Gift size={20} className="sm:w-6 sm:h-6" />
                        </div>
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-800">Light Loto</h3>
                    </div>

                    <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 relative z-10">
                        Каждый день новый шанс выиграть джекпот или другие ценные призы.
                    </p>

                    <div className="bg-amber-500/5 rounded-lg p-2.5 sm:p-3 mb-3 sm:mb-4">
                        <div className="flex justify-between mb-1">
                            <span className="text-xs sm:text-sm text-gray-600">Джекпот:</span>
                            <span className="text-xs sm:text-sm font-medium text-amber-500">От 100 USDT</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-xs sm:text-sm text-gray-600">Попыток в день:</span>
                            <span className="text-xs sm:text-sm font-medium text-amber-500">Неограниченно</span>
                        </div>
                    </div>

                    <div className="absolute bottom-0 right-0 left-0 bg-amber-500/10 py-1.5 sm:py-2 px-4 sm:px-6 flex justify-end">
                        <span className="text-sm sm:text-base text-amber-500 font-medium flex items-center">
                            Подробнее <ArrowRight size={14} className="ml-1 sm:w-4 sm:h-4" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClusterSelectionGrid;
